window.Eurus = window.Eurus || {};
window.Eurus.loadedScript = window.Eurus.loadedScript || new Set();

if (!window.Eurus.loadedScript.has('max-order-quantity.js')) {
  window.Eurus.loadedScript.add('max-order-quantity.js');

  const formsSelector =
    'form[data-type="add-to-cart-form"][data-product-id][data-max-order-quantity]';
  const cartInputSelector =
    'input.cart-qty[data-product-id][data-max-order-quantity]';

  const toPositiveInteger = (value) => {
    const parsed = parseInt(value, 10);
    return Number.isFinite(parsed) && parsed > 0 ? parsed : null;
  };

  const toNonNegativeInteger = (value) => {
    const parsed = parseInt(value, 10);
    return Number.isFinite(parsed) && parsed >= 0 ? parsed : 0;
  };

  const setButtonDisabled = (button, disabled) => {
    if (!button) return;
    button.disabled = disabled;

    // Ne forcer le display que pour les boutons "add to cart" de la fiche produit
    // Pas pour les boutons +/- du panier (qui ont data-cart-qty-action)
    const isAddToCartButton = button.name === 'add';
    const isCartQtyButton = button.dataset.cartQtyAction !== undefined;

    if (isAddToCartButton) {
      // Forcer l'affichage du bouton même si disabled
      // Important: utiliser removeAttribute pour supprimer le style inline du Liquid
      if (disabled) {
        button.setAttribute('aria-disabled', 'true');
        // Forcer la visibilité avec !important via setAttribute
        button.style.setProperty('display', 'block', 'important');
      } else {
        button.removeAttribute('aria-disabled');
        button.style.removeProperty('display');
      }
    } else if (isCartQtyButton) {
      // Pour les boutons +/- du panier, forcer aussi la visibilité
      if (disabled) {
        button.setAttribute('aria-disabled', 'true');
        // S'assurer que le bouton reste visible même disabled
        button.style.setProperty('display', 'flex', 'important');
        button.style.setProperty('visibility', 'visible', 'important');
        button.style.setProperty('opacity', '0.4', 'important');
      } else {
        button.removeAttribute('aria-disabled');
        button.style.removeProperty('display');
        button.style.removeProperty('visibility');
        button.style.removeProperty('opacity');
      }
    } else {
      // Pour les autres boutons, juste aria-disabled
      if (disabled) {
        button.setAttribute('aria-disabled', 'true');
      } else {
        button.removeAttribute('aria-disabled');
      }
    }
  };

  const getLimitMessage = (limit) => {
    if (
      window.Eurus &&
      typeof window.Eurus.max_order_quantity_error_html === 'string'
    ) {
      return window.Eurus.max_order_quantity_error_html.replace('[quantity]', limit);
    }
    return `Maximum quantity allowed for this product is ${limit}`;
  };

  const getCartLimitMessage = (limit) => {
    if (
      window.Eurus &&
      typeof window.Eurus.max_order_quantity_cart_html === 'string'
    ) {
      return window.Eurus.max_order_quantity_cart_html.replace('[quantity]', limit);
    }
    return `Max quantity: ${limit}`;
  };

  const showFormInfoMessage = (form, limit) => {
    // Ne pas afficher le message sur les vignettes produit (card-product)
    const isProductCard = form.closest('.card-product') !== null;
    if (isProductCard) return;

    const productId = form.dataset.productId;
    const messageId = `max-order-info-${productId}`;
    let messageEl = document.getElementById(messageId);

    if (!messageEl) {
      // Créer le message informatif permanent
      messageEl = document.createElement('div');
      messageEl.id = messageId;
      messageEl.className = 'max-order-info-message text-sm mt-3 mb-3 p-3 rounded';
      messageEl.style.backgroundColor = 'rgba(var(--color-background-secondary, 245, 245, 245), 1)';
      messageEl.style.border = '1px solid rgba(var(--color-border, 229, 229, 229), 1)';
      messageEl.style.color = 'rgba(var(--color-foreground, 51, 51, 51), 1)';

      // Trouver le conteneur parent du formulaire pour insérer après
      const productForm = form.closest('[x-data]');
      if (productForm) {
        // Chercher le message d'erreur Alpine.js
        const errorMessage = productForm.querySelector('[x-ref="error_message"]');
        if (errorMessage && errorMessage.parentElement) {
          // Insérer après le message d'erreur Alpine.js
          const errorContainer = errorMessage.closest('[role="alert"]');
          if (errorContainer && errorContainer.parentElement) {
            errorContainer.parentElement.insertBefore(messageEl, errorContainer.nextSibling);
          } else {
            errorMessage.parentElement.insertBefore(messageEl, errorMessage.nextSibling);
          }
        } else {
          // Si pas de message d'erreur trouvé, insérer après le formulaire
          form.parentElement.insertBefore(messageEl, form.nextSibling);
        }
      } else {
        // Fallback : insérer après le formulaire
        form.parentElement.insertBefore(messageEl, form.nextSibling);
      }
    }

    messageEl.innerHTML = getLimitMessage(limit);
    messageEl.style.display = 'block';
  };

  const hideFormInfoMessage = (form) => {
    const productId = form.dataset.productId;
    const messageId = `max-order-info-${productId}`;
    const messageEl = document.getElementById(messageId);
    if (messageEl) {
      messageEl.style.display = 'none';
    }
  };

  const showLimitError = (input, limit) => {
    const lineKey = input.dataset.lineKey;
    if (!lineKey) return;
    const wrapper = document.getElementById(`LineItemError-${lineKey}`);
    if (!wrapper) return;
    wrapper.classList.remove('hidden');
    const text = wrapper.querySelector('.cart-item__error-text');
    if (text) text.innerHTML = getLimitMessage(limit);
  };

  const hideLimitError = (input) => {
    const lineKey = input.dataset.lineKey;
    if (!lineKey) return;
    const wrapper = document.getElementById(`LineItemError-${lineKey}`);
    if (wrapper) wrapper.classList.add('hidden');
  };

  const showCartLimitMessage = (input, limit) => {
    const lineKey = input.dataset.lineKey;
    if (!lineKey) return;

    const messageId = `cart-max-info-${lineKey}`;
    let messageEl = document.getElementById(messageId);

    if (!messageEl) {
      // Créer le message informatif (texte simple, sans encadré)
      messageEl = document.createElement('div');
      messageEl.id = messageId;
      messageEl.className = 'cart-max-info-message text-xs mt-2 mb-2 opacity-70';

      // Trouver le conteneur cart-item__quantity
      const qtyContainer = input.closest('.cart-item__quantity');
      if (qtyContainer && qtyContainer.parentElement) {
        // Insérer le message juste avant le conteneur de quantité
        qtyContainer.parentElement.insertBefore(messageEl, qtyContainer);
      }
    }

    messageEl.innerHTML = getCartLimitMessage(limit);
    messageEl.style.display = 'block';
  };

  const hideCartLimitMessage = (input) => {
    const lineKey = input.dataset.lineKey;
    if (!lineKey) return;
    const messageId = `cart-max-info-${lineKey}`;
    const messageEl = document.getElementById(messageId);
    if (messageEl) {
      messageEl.style.display = 'none';
    }
  };

  let cartTotals = new Map(); // productId -> quantity presently tracked

  const setProductTotal = (productId, quantity) => {
    if (quantity > 0) {
      cartTotals.set(productId, quantity);
    } else {
      cartTotals.delete(productId);
    }
  };

  const captureCartInputs = () => {
    const domTotals = new Map();

    document.querySelectorAll(cartInputSelector).forEach((input) => {
      const quantity = toNonNegativeInteger(input.value);
      input.dataset.currentQuantity = quantity;
      const productId = input.dataset.productId;
      if (!productId) return;
      domTotals.set(productId, (domTotals.get(productId) || 0) + quantity);
    });

    if (cartTotals.size === 0 && domTotals.size > 0) {
      cartTotals = domTotals;
    }
  };

  const showFormLimitMessage = (form, limit) => {
    // Utiliser le système d'erreur Alpine.js existant
    const productForm = form.closest('[x-data]');
    if (productForm && productForm.__x) {
      const alpineData = productForm.__x.$data;
      if (alpineData) {
        alpineData.errorMessage = true;
        const errorMessageEl = productForm.querySelector('[x-ref="error_message"]');
        if (errorMessageEl) {
          errorMessageEl.textContent = getLimitMessage(limit);
        }
      }
    }
  };

  const hideFormLimitMessage = (form) => {
    // Masquer le message d'erreur Alpine.js
    const productForm = form.closest('[x-data]');
    if (productForm && productForm.__x) {
      const alpineData = productForm.__x.$data;
      if (alpineData) {
        alpineData.errorMessage = false;
      }
    }
  };

const showPermanentLimitMessage = (form, limit) => {
    const isProductCard = form.closest('.card-product') !== null;
    if (isProductCard) return;

    const productId = form.dataset.productId;
    const messageId = `max-order-permanent-${productId}`;
    if (document.getElementById(messageId)) return;

        const messageEl = document.createElement('p');
    messageEl.id = messageId;
    messageEl.className = 'max-order-permanent-message product-bundle';
    messageEl.style.fontSize = '0.875rem';
    messageEl.style.opacity = '0.8';
    messageEl.style.margin = '0';
    messageEl.innerHTML = ` Commande limitée à ${limit} bouteille(s) par personne`;

    // Insérer à droite du prix dans le flex container
    const priceBlocks = document.querySelectorAll('.x-block-price');
    let targetFlexContainer = null;

    priceBlocks.forEach(block => {
      const priceDiv = block.querySelector(`[bss-b2b-product-id="${productId}"]`);
      if (priceDiv) targetFlexContainer = priceDiv;
    });

    if (targetFlexContainer) {
      const mainPrice = targetFlexContainer.querySelector('.main-product-price');
      if (mainPrice && mainPrice.parentElement) {
        mainPrice.parentElement.insertBefore(messageEl, mainPrice.nextSibling);
        return;
      }
    }

    // Fallback
    form.parentElement.insertBefore(messageEl, form);
  }
  const applyFormLimits = () => {
    document.querySelectorAll(formsSelector).forEach((form) => {
      const productId = form.dataset.productId;
      const limit = toPositiveInteger(form.dataset.maxOrderQuantity);
      if (!productId || !limit) return;

      // Afficher le message permanent dès le chargement
      showPermanentLimitMessage(form, limit);

      const used = cartTotals.get(productId) || 0;
      const remaining = Math.max(limit - used, 0);

      const addButton = form.querySelector('button[name="add"]');
      const isLimitReached = remaining <= 0;

      setButtonDisabled(addButton, isLimitReached);

      // Afficher le message d'erreur Alpine.js + le message informatif
      if (isLimitReached) {
        showFormLimitMessage(form, limit);
        showFormInfoMessage(form, limit);
      } else {
        hideFormLimitMessage(form);
        hideFormInfoMessage(form);
      }

      const quantityInput = form.querySelector('input[name="quantity"]');
      if (!quantityInput) return;

      // Définir le max en fonction de la quantité restante
      if (remaining > 0) {
        quantityInput.setAttribute('max', remaining);
        quantityInput.removeAttribute('disabled');

        const current = toNonNegativeInteger(quantityInput.value);
        if (current > remaining) {
          quantityInput.value = remaining;
        } else if (current === 0) {
          quantityInput.value = 1;
        }
      } else {
        quantityInput.setAttribute('max', 0);
        quantityInput.setAttribute('disabled', 'disabled');
        if (quantityInput.value === '0' || quantityInput.value === '') {
          quantityInput.value = 1;
        }
      }

      const formContainer = form.closest('[x-ref="product_form_container"]') || form.parentElement;
      const plusButtons = formContainer.querySelectorAll('button[name="plus"]');
      const minusButtons = formContainer.querySelectorAll('button[name="minus"]');

      plusButtons.forEach(btn => btn.disabled = isLimitReached);
      minusButtons.forEach(btn => btn.disabled = isLimitReached);
    });
  };

  const applyCartLimits = () => {
    document
      .querySelectorAll('[data-cart-item] [data-cart-qty-action="plus"]')
      .forEach((button) => setButtonDisabled(button, false));

    document
      .querySelectorAll('[data-cart-item]')
      .forEach((item) => {
        const input = item.querySelector(cartInputSelector);
        if (!input) return;

        const productId = input.dataset.productId;
        const limit = toPositiveInteger(input.dataset.maxOrderQuantity);
        if (!productId || !limit) return;

        const lineQuantity = toNonNegativeInteger(input.dataset.currentQuantity);
        const total = cartTotals.get(productId) || 0;
        const others = Math.max(total - lineQuantity, 0);
        const allowed = Math.max(limit - others, 0);
        const isAtLimit = lineQuantity >= allowed;

        item
          .querySelectorAll('[data-cart-qty-action="plus"]')
          .forEach((button) => setButtonDisabled(button, isAtLimit));

        // Afficher le message informatif si la limite est atteinte
        if (isAtLimit) {
          showCartLimitMessage(input, limit);
        } else {
          hideCartLimitMessage(input);
        }

        if (lineQuantity < allowed) hideLimitError(input);
      });
  };

  const updateUi = () => {
    applyCartLimits();
    applyFormLimits();
  };

  const enforceCartQuantity = (input, desired, options = {}) => {
    const productId = input.dataset.productId;
    const limit = toPositiveInteger(input.dataset.maxOrderQuantity);
    if (!productId || !limit) {
      updateUi();
      return true;
    }

    const previous = toNonNegativeInteger(input.dataset.currentQuantity);
    const withoutLine = Math.max((cartTotals.get(productId) || 0) - previous, 0);
    const allowed = Math.max(limit - withoutLine, 0);

    let final = desired;
    if (desired > allowed) {
      final =
        options.restorePrevious && previous !== null
          ? Math.min(previous, allowed)
          : Math.min(desired, allowed);
      showLimitError(input, limit);
    } else {
      hideLimitError(input);
    }

    if (final !== desired) {
      input.value = final;
    }

    input.dataset.currentQuantity = final;
    setProductTotal(productId, withoutLine + final);
    updateUi();

    return final === desired;
  };

  const fetchCartTotals = () =>
    fetch('/cart.js', { credentials: 'same-origin' })
      .then((response) => response.json())
      .then((cart) => {
        const totals = new Map();
        if (cart && Array.isArray(cart.items)) {
          cart.items.forEach((item) => {
            const productId = String(item.product_id);
            totals.set(
              productId,
              (totals.get(productId) || 0) + item.quantity,
            );
          });
        }
        cartTotals = totals;
        captureCartInputs();
        updateUi();
      })
      .catch(() => {
        captureCartInputs();
        updateUi();
      });

  const closest = (target, selector) => {
    if (!(target instanceof Element)) return null;
    return target.closest(selector);
  };

  document.addEventListener(
    'input',
    (event) => {
      const input = closest(event.target, cartInputSelector);
      if (!input) return;

      const desired = toNonNegativeInteger(input.value);
      enforceCartQuantity(input, desired);
    },
    true,
  );

  document.addEventListener(
    'change',
    (event) => {
      const input = closest(event.target, cartInputSelector);
      if (!input) return;

      const desired = toNonNegativeInteger(input.value);
      if (!enforceCartQuantity(input, desired, { restorePrevious: true })) {
        event.preventDefault();
        event.stopImmediatePropagation();
      }
    },
    true,
  );

  document.addEventListener(
    'click',
    (event) => {
      const control = closest(event.target, '[data-cart-qty-action]');
      if (!control) return;

      const container = closest(control, '[data-cart-item]');
      if (!container) return;
      const input = container.querySelector(cartInputSelector);
      if (!input) return;

      const step = toPositiveInteger(input.getAttribute('step')) || 1;
      const current = toNonNegativeInteger(input.dataset.currentQuantity);
      let desired = current;

      if (control.dataset.cartQtyAction === 'plus') {
        desired = current + step;
      } else if (control.dataset.cartQtyAction === 'minus') {
        desired = Math.max(current - step, 0);
      } else {
        return;
      }

      if (!enforceCartQuantity(input, desired)) {
        event.preventDefault();
        event.stopImmediatePropagation();
      }
    },
    true,
  );

  // Écouteur sur le champ de quantité pour bloquer la saisie
  document.addEventListener(
    'input',
    (event) => {
      const input = event.target;
      if (!input.name || input.name !== 'quantity') return;

      const form = closest(input, formsSelector);
      if (!form) return;

      const productId = form.dataset.productId;
      const limit = toPositiveInteger(form.dataset.maxOrderQuantity);
      if (!productId || !limit) return;

      const used = cartTotals.get(productId) || 0;
      const remaining = Math.max(limit - used, 0);
      const requestedQuantity = toNonNegativeInteger(input.value);

      if (requestedQuantity > remaining && remaining > 0) {
        input.value = remaining;
        showFormLimitMessage(form, limit);
        showFormInfoMessage(form, limit);
      } else if (requestedQuantity === 0 && remaining > 0) {
        // Ne pas permettre 0, remettre à 1
        input.value = 1;
      } else if (remaining > 0) {
        hideFormLimitMessage(form);
        hideFormInfoMessage(form);
      }
    },
    true,
  );

  document.addEventListener(
    'submit',
    (event) => {
      const form = closest(event.target, formsSelector);
      if (!form) return;

      const productId = form.dataset.productId;
      const limit = toPositiveInteger(form.dataset.maxOrderQuantity);
      if (!productId || !limit) return;

      const quantityInput = form.querySelector('input[name="quantity"]');
      if (!quantityInput) return;

      const requestedQuantity = toNonNegativeInteger(quantityInput.value);
      const used = cartTotals.get(productId) || 0;
      const remaining = Math.max(limit - used, 0);

      if (requestedQuantity > remaining) {
        event.preventDefault();
        event.stopImmediatePropagation();

        // Ajuster la quantité à la valeur maximale autorisée
        quantityInput.value = remaining;

        // Afficher le message d'erreur
        showFormLimitMessage(form, limit);

        return false;
      }
    },
    true,
  );

  document.addEventListener('eurus:cart:items-changed', () => {
    fetchCartTotals();
  });

let debounceTimer = null;

  const observer = new MutationObserver((mutations) => {
    const shouldUpdate = mutations.some((mutation) => {
      if (mutation.target.classList &&
          (mutation.target.classList.contains('max-order-info-message') ||
           mutation.target.classList.contains('cart-max-info-message'))) {
        return false;
      }
      const nodes = [...mutation.addedNodes, ...mutation.removedNodes];
      return !nodes.some(node => node.classList &&
        (node.classList.contains('max-order-info-message') ||
         node.classList.contains('cart-max-info-message')));
    });

    if (shouldUpdate) {
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(() => {
        captureCartInputs();
        updateUi();
      }, 50);
    }
  });

  const observerTarget = document.getElementById('MainContent') || document.documentElement;

  observer.observe(observerTarget, {
    childList: true,
    subtree: true,
  });

  captureCartInputs();
  updateUi();
  fetchCartTotals();
}
